import React from 'react';
import { NavLink } from 'react-router-dom';
import './Menu.css';

const Menu = () => {
    return (
        <div className="menu">
            <NavLink to="/">Projects</NavLink>
            <NavLink to="/about">About</NavLink>
        </div>
    )
}

export default Menu;